<ion-header
  class="ion-no-border"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons
      *ngIf="(platformService?.isTouchExperience$ | async) === false"
      slot="end"
    >
      <ion-button
        data-cy="close-modal-button"
        class="close-modal-button"
        (click)="closeModal()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label>
      {{ 'i18n.orderSubmittedPage.sortFilterProductsModal.title' | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
>
  <div class="label-padding">
    <ion-label data-cy="sort-by-label">
      {{ 'i18n.orderSubmittedPage.sortFilterProductsModal.sortBy' | translate }}
    </ion-label>
  </div>
  <ion-item-divider></ion-item-divider>
  <ion-item
    [ngClass]="sortDirection === SortDirections.asc ? 'selected' : ''"
    (click)="itemSelected(SortDirections.asc)"
  >
    <ion-label data-cy="order-submitted-sort">{{
      'i18n.orderSubmittedPage.sortFilterProductsModal.reserved' | translate
    }}</ion-label>
    <div class="sort-direction-container">
      <span>{{
        'i18n.orderSubmittedPage.sortFilterProductsModal.sortAscending'
          | translate
      }}</span>
      <div *ngIf="sortDirection === SortDirections.asc; else sortAscGray">
        <ion-img src="assets/icon/sort-asc.svg"></ion-img>
      </div>
      <ng-template #sortAscGray>
        <ion-img src="assets/icon/sort-asc-gray.svg"></ion-img>
      </ng-template>
    </div>
  </ion-item>
  <ion-item
    class="last-item-border"
    [ngClass]="sortDirection === SortDirections.desc ? 'selected' : ''"
    (click)="itemSelected(SortDirections.desc)"
  >
    <ion-label data-cy="order-submitted-sort">{{
      'i18n.orderSubmittedPage.sortFilterProductsModal.reserved' | translate
    }}</ion-label>
    <div class="sort-direction-container">
      <span>{{
        'i18n.orderSubmittedPage.sortFilterProductsModal.sortDescending'
          | translate
      }}</span>
      <div *ngIf="sortDirection === SortDirections.desc; else sortDscGray">
        <ion-img src="assets/icon/sort-desc.svg"></ion-img>
      </div>
      <ng-template #sortDscGray>
        <ion-img src="assets/icon/sort-desc-gray.svg"></ion-img>
      </ng-template>
    </div>
  </ion-item>
  <ion-item-divider></ion-item-divider>

  <div class="label-padding">
    <ion-label data-cy="sort-by-label">
      {{
        'i18n.orderSubmittedPage.sortFilterProductsModal.filterBy' | translate
      }}
    </ion-label>
  </div>
  <ion-item-divider></ion-item-divider>
  <ion-item
    class="last-item-border"
    [class.selected]="filterSelection"
    (click)="setFilter()"
  >
    <ion-label id="unreserved" data-cy="unreserved-label">
      {{
        'i18n.orderSubmittedPage.sortFilterProductsModal.unreservedProducts'
          | translate
      }}
    </ion-label>
    <app-usf-checkbox
      aria-labelledby="unreserved"
      [invertColors]="true"
      data-cy="click-unreserved-products-checkbox"
      [isSelected]="filterSelection"
    ></app-usf-checkbox>
  </ion-item>
  <ion-item-divider></ion-item-divider>
</ion-content>

<ion-footer
  class="ion-footer-modal"
  [class.ion-footer-modal-desktop]="
    (platformService?.isTouchExperience$ | async) === false
  "
>
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        [ngClass]="
          platformService?.platformType !==
          platformService?.platformEnum?.mobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        data-cy="sort-modal-clear-all-button"
        (click)="clearAll()"
      >
        {{ 'i18n.common.clearAll' | translate }}
      </ion-button>
      <ion-button
        [ngClass]="
          platformService?.platformType !==
          platformService?.platformEnum?.mobile
            ? 'usf-fill-green-dsktp-tblt-modal-button'
            : 'usf-fill-green-mobile-modal-button'
        "
        data-cy="sort-modal-save-button"
        (click)="applyAndClose()"
      >
        {{ 'i18n.common.apply' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
